import React, { useState } from "react";

import { languages } from "@pages/translationsPage/constants/languages";

export const useCurrentLanguage = (): [string, React.Dispatch<React.SetStateAction<string>>] => {
    const [selectedLanguage, changeSelectedLanguage] = useState(languages[0].code);
    return [selectedLanguage, changeSelectedLanguage];
};
